<template>
  <i class="iconfont" :class="`icon-${name}`" :style="{fontSize: `${fontSize}rem`, color: color, marginLeft: `${marginLeft}rem`, marginRight: `${marginRight}rem`}"></i>
</template>

<script>
export default {
  name: "iconFont",
  props: {
    name: {
      type: String,
      default: '',
    },
    fontSize: {
      type: Number,
      default: 1.2,
    },
    color: {
      type: String,
      default: '',
    },
    marginLeft: {
      type: Number,
      default: 0,
    },
    marginRight: {
      type: Number,
      default: 0,
    },
  }
};
</script>

<style scoped lang="scss">

</style>